module.exports = __webpack_public_path__ + "img/real-time.c1770f54.png";